import React from "react";

function Teaching0203() {
	return (
	<div className="content_inpage">
		<div className="pagesize">
			<ul className="bread">
				<li><a href="/">首頁</a></li>						
				<li><a href="/container/teaching">教學&QA</a></li>
				<li><a href="/container/teaching/Teaching0203">代步車教學</a></li>
			</ul>		
					
			<h2 className="tit_main">代步車教學</h2>
			<div className="content_box">
				<div className="steps steps_x3 flex_set">
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step1</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_car01.jpg").default} alt="img_step_car01" /></div>
						<div className="sb_txt">
							<p>從首頁點擊「我的 i寶貝(音箱名)」</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step2</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_car02.jpg").default} alt="img_step_car02" /></div>
						<div className="sb_txt">
							<p>在音箱管理頁點擊「技能開通」。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step3</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_car03.jpg").default} alt="img_step_car03" /></div>
						<div className="sb_txt">
							<p>在技能開通頁，找「 i 寶車 (千里馬)」，點擊右方的加號進行代步車的配對。</p>
						</div>
					</div>
				</div>
				<div className="steps steps_x3 flex_set">
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step4</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_car04.jpg").default} alt="img_step_car04" /></div>
						<div className="sb_txt">
							<p>開啟掃描框對著代步車(或代步車說明書)上的QR Code掃描。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step5</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_car05.jpg").default} alt="img_step_car05" /></div>
						<div className="sb_txt">
							<p>接著選擇代步車的使用人(暱稱)，選擇完畢點擊下一步。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step6</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_car06.jpg").default} alt="img_step_car06" /></div>
						<div className="sb_txt">
							<p>配對完成之代步車會顯示於 i 寶貝技能開通內頁。若欲移除代步車，請點選代步車icon右上方之清除鈕。</p>
						</div>
					</div>
				</div>
			</div>
		</div>						
	</div>
	)
}

export default Teaching0203;